module.exports = __webpack_public_path__ + "img/dtgt-check.299f402c.jpg";